import React, { FunctionComponent } from 'react';

import { WaitingList as WaitingListType } from '@gojob/cms';
import useTheme from '@gojob/ui-bits/styles/useTheme';
import { graphql } from 'gatsby';

import Image from '../../Section/WaitingList/Image';
import TextContents from '../../Section/WaitingList/TextContents';

export const WaitingListFragment = graphql`
  fragment WaitingListFragment on SanityWaitinglist {
    title {
      title
      level
    }
    description
    cta {
      ...CtaFragment
    }
    variant {
      variant
    }
    image {
      alt
      asset {
        localFile {
          childImageSharp {
            gatsbyImageData(placeholder: BLURRED)
          }
        }
      }
    }
  }
`;

const useStyles = () => {
  const { spacing, breakpoint } = useTheme();
  return {
    root: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      maxWidth: breakpoint.values.lg,
      padding: spacing(8, 4, 4),
      rowGap: spacing(4),
      columnGap: spacing(4),
      [breakpoint.up('md')]: {
        flexDirection: 'row',
      },
    },
    textContainer: {
      flex: '1 1 50%',
    },
    imageContainer: {
      flex: '1 1 50%',
    },
    image: {
      width: '100%',
      maxWidth: breakpoint.values.sm,
      maxHeight: breakpoint.values.sm,
    },
  } as const;
};

const WaitingList: FunctionComponent<WaitingListType> = (props) => {
  const { title, cta, description, image } = props;

  const classes = useStyles();

  return (
    <div css={classes.root}>
      <TextContents css={classes.textContainer} title={title} description={description} cta={cta} />
      <Image css={classes.imageContainer} image={image} />
    </div>
  );
};

export default WaitingList;
